import { DESCRIPTION_DATAITEM_ID } from './../../ui/shape-data-editor/dataitems-id';
import { IDataItem, DataType, IEntityDataItemDef } from 'flux-definition';
import { Injectable } from '@angular/core';
import { Command, Random } from 'flux-core';
import { EDataChangeService } from '../edata-change.svc';
import { AbstractEDataChangeCommand } from './abstract-edata-change-command.cmd';
import values from 'lodash/values';
import { EDataModel } from '../model/edata.mdl';


/**
 * This command add or replace the entityDefs ( bluepirints of entities ) in the
 * Edata model
 *
 */
@Injectable()
@Command()
export class AddNewEntityDefs extends AbstractEDataChangeCommand {

    // tslint:disable:member-ordering
    constructor(
        protected es: EDataChangeService,
    ) {
        super( es ) /* istanbul ignore next */;
    }

    /**
     * Input data format for the command
     */
    public data:  {
        dataItems: { [dataItemId: string]: IEntityDataItemDef };
        edataModel: EDataModel,
        entityDefId: string,
    };

    public prepareData() {

        const dItems = values( this.data.dataItems )
            .filter( dataItem => ( dataItem.isPublic === true || dataItem.isPublic === undefined ));
        let skipList = [];
        if ( !this.changeModel.isCustom ) {
            const eDef = this.changeModel.getDefinition();
            const entityDef = eDef.entityDefs[this.data.entityDefId];
            if ( entityDef && entityDef.dataItems ) {
                skipList = Object.keys( entityDef.dataItems );
                const shapeDef = entityDef.shapeDefs && entityDef.shapeDefs[this.data.edataModel.defId];
                if ( shapeDef && shapeDef.dataMap ) {
                    const fieldMap = {};
                    shapeDef.dataMap.forEach( m => {
                        fieldMap[m.eDataFieldId] = m.dataItemId;
                    });
                    for ( let i = 0; i < skipList.length; i++ ) {
                        if ( fieldMap[skipList[i]]) {
                            skipList[i] = fieldMap[skipList[i]];
                        }
                    }
                }
            }
        }
        const dataItems = this.getEntityDefsDataItems( dItems, skipList );
        let defValue;
        defValue = {
            id: this.data.entityDefId,
            dataItems,
        };

        if ( !this.changeModel.customEntityDefs ) {
            this.changeModel.customEntityDefs = {};
        }
        const cEntityDef = this.changeModel.customEntityDefs[ this.data.entityDefId ];
        if ( !cEntityDef ) { // No def found, we add a new def
            this.changeModel.customEntityDefs[ this.data.entityDefId ] = defValue;
        }

        if ( this.changeModel.dataDefs ) {
            const dataItemIds = Object.keys( dataItems );
            const entityIds = this.changeModel.getEntitiesByDefId( this.data.entityDefId ).map( e => e.id );
            entityIds.forEach( eId => {
                const dDef = this.changeModel.dataDefs[ eId ];
                if ( dDef ) {
                    dataItemIds.forEach( dId => {
                        delete dDef[dId];
                    });
                    if ( Object.keys( dDef ).length === 0 ) {
                        delete this.changeModel.dataDefs[ eId ];
                    }
                }
            });
        }
    }


    protected getEntityDefsDataItems( diList: IDataItem<any>[], skipList: string[]) {
        const dataItems = {};
        diList.forEach( item => {
            if ( item.id && ( item.id === DESCRIPTION_DATAITEM_ID || skipList.indexOf( item.id ) === -1 )) {
                dataItems[ item.id ] = {
                    default: this.getDefaultValueForType( item ),
                    ...item,
                };
                dataItems[ item.id ].isTypeBound = true;
                dataItems[ item.id ].removeable = false;
                dataItems[ item.id ].labelEditable = false;
            }
        });
        const hasPrimaryTextBoundDI: boolean = diList
        .some(( item: any ) =>  item.primaryTextBound === true );
        /**
         * Add a hidden data item to bind to the primary text model
         */
        if ( !hasPrimaryTextBoundDI ) {
            const id = Random.dataItemId();
            dataItems[id] = this.createTextDataItem( id );
        }
        return dataItems;
    }

    private getDefaultValueForType( dataItem: IDataItem<any> ) {
        if ( dataItem.type === DataType.LOOKUP ) {
            return [];
        }
        if ( dataItem.value ) {
            return dataItem.value;
        }
        if ( dataItem.type === DataType.USERS ) {
            return {
                source: {},
                people: [],
            };
        }
        if ( dataItem.type === DataType.TAGS ) {
            return [];
        }
        return '';
    }


    private createTextDataItem( id: string ) {
        return {
            id,
            type: DataType.STRING,
            visibility: [],
            default: '',
            value: '',
            label: '',
            labelEditable: true,
            optional: true,
            validationRules: {},
            primaryTextBound: true,
            isPublic: true,
        };
    }

}

Object.defineProperty( AddNewEntityDefs, 'name', {
    value: 'AddNewEntityDefs',
});
